import { render, staticRenderFns } from "./MemberOneToOneChat.vue?vue&type=template&id=6ba7a9da"
import script from "./MemberOneToOneChat.vue?vue&type=script&lang=js"
export * from "./MemberOneToOneChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports